import { localize } from 'i18n/localize.ts';
import { CATEGORY_ALL_CATEGORIES_SEO_NAME } from 'utils/constants.ts';

export type CategoryPath = {
	name: string;
};

export type ResponseCategoryData = {
	adverts_count?: number;
	id: number;
	level: number;
	name: string;
	parent_id: null | number;
	path: CategoryPath[] | undefined;
	seo_keywords: string;
	seo_name: string;
	title: string;
};

export type CategoryData = {
	offersCount?: number;
	id: number;
	level: number;
	name: string;
	parentId: null | number;
	path: CategoryPath[] | undefined;
	seoKeywords: string;
	seoName: string;
	title: string;
};

export type CategorySuggests = {
	id: number;
	name: string;
	path?: CategorySuggests[] | undefined;
};

export function normalizeCategoryData(categoryData: ResponseCategoryData): CategoryData {
	return {
		offersCount: categoryData.adverts_count,
		id: categoryData.id,
		level: categoryData.level,
		name: categoryData.name,
		parentId: categoryData.parent_id,
		path: categoryData.path,
		seoKeywords: categoryData.seo_keywords,
		seoName: categoryData.seo_name,
		title: categoryData.title,
	};
}

export type ResponseOfferCategoryData = Pick<ResponseCategoryData, 'id' | 'name' | 'seo_name' | 'adverts_count'>;

export type OfferCategoryData = Pick<CategoryData, 'id' | 'name' | 'seoName' | 'offersCount'>;

const $t = localize();

export function normalizeOfferCategoryData(categoryData: ResponseOfferCategoryData): OfferCategoryData {
	return {
		id: categoryData.id,
		name: categoryData.name,
		seoName: categoryData.seo_name,
		offersCount: categoryData.adverts_count,
	};
}

export function denormalizeOfferCategoryData(categoryData: OfferCategoryData): ResponseOfferCategoryData {
	return {
		id: categoryData.id,
		name: categoryData.name,
		seo_name: categoryData.seoName,
		adverts_count: categoryData.offersCount,
	};
}

export const CATEGORY_ALL_CATEGORIES: CategoryData = {
	id: 0,
	seoName: CATEGORY_ALL_CATEGORIES_SEO_NAME,
	title: $t.categories.allCategories,
	name: $t.categories.allCategories,
	level: 0,
	parentId: null,
	path: [],
	seoKeywords: '',
} as const;

export function getCategoryPath(categoryId: number, categoryList: CategoryData[]): CategoryData[] {
	const categoryData = categoryList.find(({ id }) => id === categoryId);

	// neexistující kategorie
	if (!categoryData) {
		return [];
	}

	if (categoryData.parentId) {
		return [...getCategoryPath(categoryData.parentId, categoryList), categoryData];
	} else {
		return [categoryData];
	}
}
